import api from './api';

// Admin Dashboard
export const adminAPI = {
  // Dashboard
  getDashboardStats: () => api.get('/admin/dashboard/stats'),
  getRecentOrders: (limit = 10) => api.get('/admin/dashboard/recent-orders', { params: { limit } }),
  
  // Products
  createProduct: (data) => api.post('/admin/products', data),
  updateProduct: (id, data) => api.put(`/admin/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`),
  getLowStockProducts: (threshold = 10) => api.get('/admin/products/low-stock', { params: { threshold } }),
  
  // Orders
  getAllOrders: (params) => api.get('/admin/orders', { params }),
  updateOrderStatus: (orderNumber, status) => api.put(`/admin/orders/${orderNumber}/status`, { status }),
  
  // Users
  getAllUsers: (params) => api.get('/admin/users', { params }),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),
  
  // Vehicles
  createVehicleMake: (data) => api.post('/admin/vehicles/makes', data),
  createVehicleModel: (data) => api.post('/admin/vehicles/models', data),
  deleteVehicleMake: (makeId) => api.delete(`/admin/vehicles/makes/${makeId}`),
  
  // Inventory
  updateStock: (productId, quantity) => api.put(`/admin/inventory/${productId}/stock`, null, { params: { quantity } }),
};

export default adminAPI;
